import { XMarkIcon } from "@";
import CodeMirror from "@uiw/react-codemirror";
import { json } from "@codemirror/lang-json";

interface PayloadDialogProps {
  payload: Record<string, unknown> | null;
  onClose: () => void;
}

export default function PayloadDialog({
  payload,
  onClose,
}: PayloadDialogProps) {
  if (!payload) return null;

  const value = JSON.stringify(payload, null, 2);

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-gray-900 bg-opacity-60 backdrop-blur-[2px]"
        onClick={onClose}
      />
      <div className="relative z-10 w-full max-w-2xl overflow-hidden rounded-2xl bg-white shadow-lg dark:border dark:border-gray-600 dark:bg-gray-800">
        <header className="flex items-center justify-between border-b p-3 dark:border-gray-700 md:px-5">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-400">
            تفاصيل الحدث
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="ms-auto inline-flex h-10 w-10 items-center justify-center rounded-full text-sm text-gray-500 hover:bg-gray-200 hover:text-gray-700 dark:hover:bg-gray-600 dark:hover:text-gray-300"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </header>
        <div dir="ltr" className="p-3">
          <CodeMirror
            value={value}
            extensions={[json()]}
            editable={false}
            readOnly
            basicSetup={{
              lineNumbers: true,
              highlightActiveLine: false,
              foldGutter: true,
            }}
          />
        </div>
      </div>
    </div>
  );
}
